export enum ParesEvaluadoresTypes
{
    PERTINENCIA = 1,
    CIENTIFICOTECNICO = 2,
    FINANCIERO = 3
}